export const cmdId = 'edit-script';